const DROPDOWN_TEXT_FIELD_NAMES = [
  "answer",
  "text1",
  "text2",
  "text3",
  "textOther",
  "textOther2",
  "textOther3",
];

export function getDropdownTextFieldConfig(question, fieldName) {
  return question && question[`${fieldName}Dropdown`]
    ? question[`${fieldName}Dropdown`]
    : null;
}

export function getDropdownTextFieldSelectionField(fieldName) {
  return `${fieldName}DropdownAnswer`;
}

export function getDropdownTextFieldOtherField(fieldName) {
  return `${fieldName}DropdownOther`;
}

export function getDropdownTextFieldOptionValue(option) {
  return typeof option === "object" ? option.value || option.label : option;
}

export function getDropdownTextFieldOptionLabel(option) {
  return typeof option === "object" ? option.label || option.value : option;
}

function getDropdownTextFieldOtherValue(config) {
  return (config && config.otherOption) || "Other";
}

export function isDropdownTextFieldOtherSelected(question, fieldName) {
  const config = getDropdownTextFieldConfig(question, fieldName);
  const selectedValue =
    question && question[getDropdownTextFieldSelectionField(fieldName)];

  return !!config && selectedValue === getDropdownTextFieldOtherValue(config);
}

export function syncDropdownTextFieldValue(question, fieldName) {
  const config = getDropdownTextFieldConfig(question, fieldName);
  if (!config) return;

  const selectedValue = question[getDropdownTextFieldSelectionField(fieldName)];
  question[fieldName] = isDropdownTextFieldOtherSelected(question, fieldName)
    ? question[getDropdownTextFieldOtherField(fieldName)] || ""
    : selectedValue || "";
}

export function clearDropdownTextFields(
  question,
  fieldNames = DROPDOWN_TEXT_FIELD_NAMES
) {
  if (!question) return;

  fieldNames.forEach((fieldName) => {
    if (!getDropdownTextFieldConfig(question, fieldName)) return;

    question[getDropdownTextFieldSelectionField(fieldName)] = "";
    question[getDropdownTextFieldOtherField(fieldName)] = "";
    question[fieldName] = "";
  });
}

export function validateDropdownTextField(question, fieldName) {
  const config = getDropdownTextFieldConfig(question, fieldName);
  if (!config) return null;
  if (config.requiredWhenField && !question[config.requiredWhenField]) return null;

  const selectedValue = question[getDropdownTextFieldSelectionField(fieldName)];
  if (!selectedValue) {
    return config.requiredMessage || "Please select from the provided options";
  }

  if (
    isDropdownTextFieldOtherSelected(question, fieldName) &&
    !(question[getDropdownTextFieldOtherField(fieldName)] || "").trim()
  ) {
    return config.otherRequiredMessage || "Please specify the other reason";
  }

  return null;
}

export function validateDropdownTextFields(question) {
  for (const fieldName of DROPDOWN_TEXT_FIELD_NAMES) {
    const validationMessage = validateDropdownTextField(question, fieldName);
    if (validationMessage) return validationMessage;
  }

  return null;
}
